<template>
  <div
    v-if="podeBaixar"
    class="text-center"
    @click.stop
  >
    <section v-if="!checkValidade(dataVencimento)">
      <v-tooltip top>
        <template #activator="{ on, attrs }">
          <v-icon
            style="cursor: pointer"
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="baixarDae()"
          >
            download
          </v-icon>
        </template>
        <span>Baixar DAE</span>
      </v-tooltip>
    </section>
    <v-dialog
      v-else
      v-model="dialog"
      width="500"
    >
      <template #activator="{ on: dialogOn, attrs: dialogAttrs }">
        <v-tooltip top>
          <template #activator="{ on: tooltipOn, attrs: tooltipAttrs }">
            <v-icon
              style="cursor: pointer"
              color="primary"
              v-bind="{ ...dialogAttrs, ...tooltipAttrs }"
              v-on="{ ...dialogOn, ...tooltipOn }"
            >
              download
            </v-icon>
          </template>
          <span>Baixar DAE</span>
        </v-tooltip>
      </template>

      <v-card>
        <v-toolbar
          color="primary"
          class="text-h6 elevation-0"
          dark
        >
          Selecione a data de vencimento
        </v-toolbar>
        <v-card-text class="pa-10">
          <v-menu
            v-model="vencimento.menu"
            :close-on-content-click="false"
            max-width="290"
          >
            <template #activator="{ on }">
              <v-text-field
                :value="dateVencimento"
                label="Data de Vencimento"
                clearable
                outlined
                readonly
                v-on="on"
                @click:clear="vencimento.date = null"
              />
            </template>
            <v-date-picker
              v-model="vencimento.date"
              :min="dateMin"
              @change="vencimento.menu = false"
            />
          </v-menu>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-btn
            text
            @click="dialog = false"
          >
            Cancelar
          </v-btn>

          <v-spacer />
          <v-btn
            :disabled="!dateVencimento"
            color="primary"
            text
            :loading="isLoadingBtn"
            @click="baixarDae()"
          >
            BAIXAR DAE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <LoaderDialog
      :active-dialog="isLoadingBtn"
      message="Baixando DAE"
    />
  </div>
</template>

<script>
import moment from "moment";
import { RevenueStatusList } from "@/models/financeiro/enum/revenue-status.enum";
import newNegociationService from "@/services/financeiro/new-negociation.service";
import AuthService from "@/services/gessan/auth.service";
import LoaderDialog from "./LoaderDialog.vue";

export default {
  name: "DialogBaixarDae",
  components: { LoaderDialog },
  props: {
    idReceita: { type: Number, required: true },
    status: { type: String, default: "" },
    cpfCnpj: { type: String, default: "" },
    dataVencimento: { type: String, default: "" },
  },
  data() {
    return {
      dialog: false,
      receitaStatus: [
        RevenueStatusList[0].value,
        RevenueStatusList[8].value,
        RevenueStatusList[13].value,
      ],
      vencimento: {
        date: null,
        menu: false,
      },
      isLoadingBtn: false,
    };
  },
  computed: {
    podeBaixar() {
      return this.receitaStatus.includes(this.status);
    },
    dateVencimento() {
      return this.vencimento.date
        ? moment(this.vencimento.date).format("DD/MM/YYYY")
        : "";
    },
    dateMin() {
      return moment().format("YYYY-MM-DD");
    },
  },
  methods: {
    acionar() {
      if (!this.checkValidade(this.dataVencimento)) {
        this.baixarDae();
      } else {
        this.dialog = true;
      }
    },
    baixarDae() {
      this.isLoadingBtn = true;

      const checkDate = this.vencimento.date || this.dataVencimento;

      newNegociationService
        .baixarDae(this.cpfCnpj, [this.idReceita.toString()], checkDate)
        .subscribe(
          res => {
            const file = new Blob([res], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(file);

            window.open(fileURL);
            this.isLoadingBtn = false;
            this.vencimento = { date: null, menu: false };
            this.dialog = false;
          },
          () => {
            this.isLoadingBtn = false;
            AuthService.globalStore("error", "Não foi possível processar a requisição");
          }
        );
    },
    checkValidade(dataVencimento) {
      const date = moment(dataVencimento).format("YYYY-MM-DD");

      return moment(date).isBefore(moment(), "day");
    },
  },
};
</script>
